module.exports = __webpack_public_path__ + "media/components/assets/icons/receipt-1e24b85d8621cbe89303a76382567740.svg";